import { ComplianceReportType } from "~/graphql/supergraphEnums";
import {
  KeyOfDocumentExportAction,
  KeyOfExportActions,
  KeyOfPositionExportActions,
} from "./constants";

export const getGeneratingModalDescriptionText = (
  selectedReportType:
    KeyOfExportActions | KeyOfDocumentExportAction | KeyOfPositionExportActions,
) => {
  switch (selectedReportType) {
    case "AuditLog":
      return "audit log";
    case "CaseInformation":
      return "case information";
    case "StatusReport":
      return "status";
    case "ScreeningStatus":
      return "screening status";
    case "FatcaCrs":
      return "FATCA/CRS";
    default:
      return "";
  }
};
export const getGeneratingModalToastText = (
  selectedReportType:
    KeyOfExportActions | KeyOfDocumentExportAction | KeyOfPositionExportActions,
) => {
  switch (selectedReportType) {
    case "AuditLog":
      return "Audit log";
    case "CaseInformation":
      return "Case information";
    case "StatusReport":
      return "Status report";
    case "ScreeningStatus":
      return "Screening Status";
    case "FatcaCrs":
      return "FATCA/CRS";
    default:
      return "";
  }
};

export const getReportTypeForMutation = (selectedReportType: KeyOfExportActions): string => {
  switch (selectedReportType) {
    case "AuditLog":
      return ComplianceReportType.AuditLog;
    case "CaseInformation":
      return ComplianceReportType.CaseDetails;
    case "StatusReport":
      return ComplianceReportType.ClientStatus;
    default:
      return "";
  }
};
